import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './contexts/LanguageContext';
import { ReadingProgressProvider } from './contexts/ReadingProgressContext';
import { ModuleReleaseProvider } from './contexts/ModuleReleaseContext';
import Layout from './components/Layout';
import Landing from './components/Landing';
import ModulePage from './components/ModulePage';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ReadingProgressProvider>
          <ModuleReleaseProvider>
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/module/:moduleId" element={<ModulePage />} />
                </Routes>
              </Layout>
            </BrowserRouter>
          </ModuleReleaseProvider>
        </ReadingProgressProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;